/* ============================================================
   radioshow
   ============================================================ */

export const radioshow = {
    id: "1",
    type: "playlist",
    featured: true,
    title: "Radioshow",
    link: "radioshow",
    playlistBg: "rgb(0, 179, 255)",
    imgUrl: "../image/set/radioshow/006.jpg", // /image/set/selection.jpg
    hoverColor: "rgb(0, 179, 255)",
    artist: "alibhtty",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "That's easy",
    artistDownload: "",
    bannerUno: "",
    downloadData: [],
    playlistImages: [
      "../image/listas/room-edition/image1.jpg",
      "../image/app/grupo.jpg",
      "../image/app/logo.jpg"
    ],
    playlistData: [
      {
        id: "1",
        songName: "Ep.015 House Sauce",
        songimg: "../image/set/radioshow/015.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/qnogflgjdoyvc77/Ep.%20015%20House%20Sause%20-%20Ali%20Bhtty.m4a",
        trackTime: "16:00"
      },
      {
        id: "2",
        songName: "Ep.014 BCN City Vibes",
        songimg: "../image/set/radioshow/014.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/azpd0pjc7ozif0n/Ep.%20014%20BCN%20City%20Vibes%20-%20Ali%20Bhtty.m4a",
        trackTime: "16:31",
        promo: "../image/set/mixtape.jpg",
        promoCategory: 2
      },
      {
        id: "3",
        songName: "Ep.013 Cy-BORED",
        songimg: "../image/set/radioshow/013.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/iw7it2twnpkxsm7/Ep.%20013%20Cy-bored%20-%20Ali%20Bhtty.m4a",
        trackTime: "14:55"
      },
      {
        id: "4",
        songName: "Ep.012 Turn It Up",
        songimg: "../image/set/radioshow/012.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/v36xlhw8ichvr4l/Ep.%20012%20Turn%20It%20Up%20-%20Ali%20Bhtty.m4a",
        trackTime: "16:34"
      },
      {
        id: "5",
        songName: "Ep.011 Blackouts",
        songimg: "../image/set/radioshow/011.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/bjffl4j12uqng34/Ep.%20011%20Blackouts%20-%20Ali%20Bhtty.m4a",
        trackTime: "19:09"
      },
      {
        id: "6",
        songName: "Ep.010 Wild Therapy",
        songimg: "../image/set/radioshow/010.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/ll7ex466kzwpt77/Ep.%20010%20Wild%20Therapy%20-%20Ali%20Bhtty.m4a",
        trackTime: "32:03"
      },
      {
        id: "7",
        songName: "Ep.009 Hard EDM & Rock",
        songimg: "../image/set/radioshow/009.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.009-Hard-EDM&Rock-Ali-Bhtty.m4a",
        trackTime: "34:41"
      },
      {
        id: "8",
        songName: "Ep.008 Reggaeton 2021",
        songimg: "../image/set/radioshow/008.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.008-Reggaeton-2021-Ali-Bhtty.m4a",
        trackTime: "32:59"
      },
      {
        id: "9",
        songName: "🅴 Ep.007 Altering Reality",
        songimg: "../image/set/radioshow/007.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/tp5aon8i5g91lwp/Ep.%20007%20Altering%20Reality%20-%20Ali%20Bhtty.m4a",
        trackTime: "39:31"
      },
      {
        id: "10",
        songName: "Ep.006 YHLQMDLG Sesion",
        songimg: "../image/set/radioshow/006.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/4f1he8ymqai22xf/Ep.%20006%20YHLQMDLG%20Bad%20Bunny%20-%20Ali%20Bhtty.m4a",
        trackTime: "34:31"
      },
      {
        id: "11",
        songName: "Ep.005 Salsatón",
        songimg: "../image/set/radioshow/005.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.005-Salsaton-Ali-Bhtty.m4a",
        trackTime: "34:41"
      },
      {
        id: "12",
        songName: "Ep.004 ElectroPOP",
        songimg: "../image/set/radioshow/004.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.004-ElectroPOP-Ali-Bhtty.m4a",
        trackTime: "32:59"
      },
      {
        id: "13",
        songName: "Ep.003 Progressive",
        songimg: "../image/set/radioshow/003.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.003-Progressive-Ali-Bhtty.m4a",
        trackTime: "34:41"
      },
      {
        id: "14",
        songName: "🅴 Ep.002 Reggaeton Old School",
        songimg: "../image/set/radioshow/002.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.002-Reggaeton-Old-School-Ali-Bhtty.m4a",
        trackTime: "32:59"
      },
      {
        id: "15",
        songName: "Ep.001 Dirty House",
        songimg: "../image/set/radioshow/001.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.001-Dirty-House-Ali-Bhtty.m4a",
        trackTime: "34:41"
      },
      {
        id: "16",
        songName: "🅴 Ep.000 Bounce Drop",
        songimg: "../image/set/radioshow/000.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://changarrito.es/assets/mus/ab/Ep.000-Bounce-Drop-Ali-Bhtty.m4a",
        trackTime: "32:59"
      }
    ]
  }
